import Vue from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)
dayjs.locale('pt-br')
const utc = {
  timeZone: 'UTC'
}

const fullDate = value =>
  new Intl.DateTimeFormat('pt-BR', { ...utc }).format(value)

const monthDate = value =>
  new Intl.DateTimeFormat('pt-BR', {
    month: 'numeric',
    year: 'numeric',
    ...utc
  }).format(value)

const compareMonthDate = (month1, month2) => {
  return monthDate(new Date(month1)) === monthDate(new Date(month2))
}

const sortJurisdictonArray = async array => {
  return array.sort((a, b) =>
    dayjs(a.month, 'MM/YYYY').diff(dayjs(b.month, 'MM/YYYY'))
  )
}

Vue.filter('date', function (value) {
  if (!value) return ''
  return fullDate(new Date(value))
})

Vue.filter('dateToFile', function () {
  return dayjs(new Date()).format('YYYYMMDDHHmm')
})

Vue.filter('actualJurisdiction', function () {
  return dayjs(new Date()).format('YYYY-MM')
})

Vue.filter('jurisdiction', function (value) {
  if (!value) return ''
  return monthDate(new Date(value))
})

Vue.filter('getAvgByMonth', async function (
  array,
  dateAttr = null,
  valueAttr = null,
  currency = false
) {
  if (!valueAttr || !dateAttr) return null

  const formatted = []

  await array.forEach(value => {
    const month = monthDate(new Date(value[dateAttr]))

    if (formatted.map(e => e.month).indexOf(month) < 0) {
      const itemsToAvg = array.filter(item =>
        compareMonthDate(value[dateAttr], item[dateAttr])
      )

      let avg =
        itemsToAvg.reduce((prevVal, elem) => (prevVal += elem[valueAttr]), 0) /
        itemsToAvg.length

      if (currency) {
        avg = avg.toFixed(2)
      }

      return formatted.push({ month, avg })
    }
  })

  return sortJurisdictonArray(formatted)
})

Vue.filter('getMultipleAvgByMonth', async function (
  array,
  dateAttr = null,
  arrayAttr = [],
  currency = false
) {
  if (arrayAttr.length === 0 || !dateAttr) return null

  const formatted = []

  await array.forEach(value => {
    const month = monthDate(new Date(value[dateAttr]))

    if (formatted.map(e => e.month).indexOf(month) < 0) {
      const itemsToAvg = array.filter(item =>
        compareMonthDate(value[dateAttr], item[dateAttr])
      )

      const toPush = arrayAttr.reduce((obj, item) => {
        let avg =
        itemsToAvg.reduce((prevVal, elem) => (prevVal += elem[item]), 0) /
        itemsToAvg.length

        if (currency) {
          avg = avg.toFixed(2)
        }

        return Object.assign({}, obj, { [item]: avg })
      }, {})

      // return formatted.push({ month, avg })
      return formatted.push({ month, ...toPush })
    }
  })

  return sortJurisdictonArray(formatted)
})

Vue.filter('getTotalByMonth', async function (
  array,
  dateAttr = null,
  valueAttr = null,
  currency = false
) {
  if (!valueAttr || !dateAttr) return null

  const formatted = []

  await array.forEach(value => {
    const month = monthDate(new Date(value[dateAttr]))

    if (formatted.map(e => e.month).indexOf(month) < 0) {
      const itemsToAvg = array.filter(item =>
        compareMonthDate(value[dateAttr], item[dateAttr])
      )

      let total = itemsToAvg.reduce(
        (prevVal, elem) => (prevVal += elem[valueAttr]),
        0
      )

      if (currency) {
        total = total.toFixed(2)
      }

      return formatted.push({ month, total })
    }
  })
  return sortJurisdictonArray(formatted)
})

Vue.filter('parseDateToDB', function (value) {
  if (!value) return null
  return dayjs(value, 'DD.MM.YYYY').format('YYYY-MM-DD')
})

export default dayjs
